import Cookies from "js-cookie";

(() => {
    // PWA Installation, SWP-325
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();

        if (!document.querySelector('#trackandtrace__searchinput')) {
            return
        }

        let ttcount = (Cookies.get('ttcount')) ? parseInt(Cookies.get('ttcount')) : 0
        ttcount = ttcount + 1
        Cookies.set('ttcount', ttcount)

        if (ttcount !== 3) {
            return
        }

        window.dataLayer.push({
            'event': 'element_sichtbarkeit',
            'element': 'sendungsverfolgung-homescreen-angezeigt'
        });

        let pwaPromptContainer = document.createElement("div")
        pwaPromptContainer.setAttribute('class', 'pwaprompt')

        let pwaPromptLogo = document.createElement('img')
        pwaPromptLogo.setAttribute('src', '/templates/gls/images/touch/homescreen144.png')
        pwaPromptLogo.setAttribute('class', 'pwaprompt__logo')

        let pwaPromptText = document.createElement('button')
        pwaPromptText.setAttribute('class', 'pwaprompt__text btn btn--link text-left')
        pwaPromptText.addEventListener('click', () => {
            e.prompt()

            window.dataLayer.push({
                'event': 'download',
                'file': 'homescreen'
            });

            pwaPromptContainer.remove()
        })
        pwaPromptText.appendChild(document.createTextNode((
            (document.querySelector('html').getAttribute('lang') === 'de-de') ? 'Sie nutzen unsere Website öfters? Dann fügen Sie uns doch Ihrem Startbildschirm hinzu! Ist sehr praktisch. ' : 'Do you use our website frequently? Then why not adding us to your home screen! It\'s very practical.'
        )))

        let pwaCloseButton = document.createElement('button')
        pwaCloseButton.setAttribute('type', 'button')
        pwaCloseButton.setAttribute('class', 'close btn-close d-block d-md-none')
        pwaCloseButton.innerHTML = '&times;';
        pwaCloseButton.addEventListener('click', () => {
            pwaPromptContainer.remove()
        })

        let pwaPromptInner = document.createElement("div")
        pwaPromptInner.setAttribute('class','pwaprompt__inner')
        pwaPromptInner.appendChild(pwaPromptLogo)
        pwaPromptInner.appendChild(pwaPromptText)
        pwaPromptInner.appendChild(pwaCloseButton)
        
        pwaPromptContainer.appendChild(pwaPromptInner)

        document.querySelector('body').appendChild(pwaPromptContainer)
    });

    window.addEventListener('appinstalled', () => {
        let alertText = (document.querySelector('html').getAttribute('lang') === 'de-de') ? 'Es kann los gehen: Website erfolgreich installiert!' : 'You are ready to go: Website successfully installed!'
        alert(alertText)
    })
}) ()

